import React from "react";
import { Link } from "react-router-dom";
import turbo from "../imagenes/Modelos/Turbo.jpg"; // <-- nueva importación
import reel from "../imagenes/Modelos/reel.jpg";


export default function Services() {
  return (
    <main className="w-full">
      {/* Hero Servicios */}
      <section
        className="bg-cover bg-center py-20 px-4 sm:px-10"
        style={{
          backgroundImage:
            `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.8)), url(${reel})`,
        }}
      >
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl font-black tracking-tight text-white">
            Venta, Reacondicionamiento y Reparación de Turbos
          </h1>
          <p className="mt-4 text-lg text-text-muted-dark">
            Soluciones confiables y rentables para mantener su motor en máximo rendimiento. Expertos en todas las marcas y modelos.
          </p>
        </div>
      </section>

      {/* Servicios de Reparación */}
      <section className="py-16 px-4 sm:px-10 bg-[#111618]">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-white">Nuestros Servicios de Reparación</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-card-dark p-6 rounded-lg text-center">
              <span className="material-symbols-outlined text-primary text-5xl">precision_manufacturing</span>
              <h3 className="text-xl font-bold mt-4 mb-2 text-white">Reparación de Turbos</h3>
              <p className="text-text-muted-dark">Análisis completo, reemplazo de piezas y calibración para un rendimiento óptimo.</p>
            </div>
            <div className="bg-card-dark p-6 rounded-lg text-center">
              <span className="material-symbols-outlined text-primary text-5xl">settings</span>
              <h3 className="text-xl font-bold mt-4 mb-2 text-white">Reparación de Cartuchos</h3>
              <p className="text-text-muted-dark">Servicio especializado para el corazón de su turbocompresor.</p>
            </div>
            <div className="bg-card-dark p-6 rounded-lg text-center">
              <span className="material-symbols-outlined text-primary text-5xl">sync_alt</span>
              <h3 className="text-xl font-bold mt-4 mb-2 text-white">Reparación de Flechas</h3>
              <p className="text-text-muted-dark">Restauramos y equilibramos flechas para evitar fallos catastróficos.</p>
            </div>
            <div className="bg-card-dark p-6 rounded-lg text-center">
              <span className="material-symbols-outlined text-primary text-5xl">build_circle</span>
              <h3 className="text-xl font-bold mt-4 mb-2 text-white">Reparaciones Detalladas</h3>
              <p className="text-text-muted-dark">Atención minuciosa a cada componente, garantizando la máxima fiabilidad.</p>
            </div>
            <div className="bg-card-dark p-6 rounded-lg text-center">
              <span className="material-symbols-outlined text-primary text-5xl">data_exploration</span>
              <h3 className="text-xl font-bold mt-4 mb-2 text-white">Equilibrio Dinámico</h3>
              <p className="text-text-muted-dark">Equilibrio de alta precisión para rotores y ejes, eliminando vibraciones.</p>
            </div>
            <div className="bg-card-dark p-6 rounded-lg text-center">
              <span className="material-symbols-outlined text-primary text-5xl">engineering</span>
              <h3 className="text-xl font-bold mt-4 mb-2 text-white">Modificaciones</h3>
              <p className="text-text-muted-dark">Mejoras y adaptaciones personalizadas para potenciar su vehículo.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Soluciones de Mantenimiento */}
      <section className="py-16 px-4 sm:px-10 bg-[#1c2327]">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-white">Soluciones de Mantenimiento Personalizadas</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="flex flex-col items-center text-center">
              <span className="material-symbols-outlined text-primary text-5xl mb-4">support_agent</span>
              <h3 className="text-xl font-bold text-white">Ingenieros de Campo</h3>
              <p className="text-text-muted-dark mt-2">Asistencia técnica especializada directamente en sus instalaciones.</p>
            </div>
            <div className="flex flex-col items-center text-center">
              <span className="material-symbols-outlined text-primary text-5xl mb-4">recycling</span>
              <h3 className="text-xl font-bold text-white">Reacondicionamiento</h3>
              <p className="text-text-muted-dark mt-2">Devolvemos la vida a sus componentes con nuestros procesos certificados.</p>
            </div>
            <div className="flex flex-col items-center text-center">
              <span className="material-symbols-outlined text-primary text-5xl mb-4">handshake</span>
              <h3 className="text-xl font-bold text-white">Acuerdos de Servicio</h3>
              <p className="text-text-muted-dark mt-2">Planes de mantenimiento preventivo y correctivo a su medida.</p>
            </div>
            <div className="flex flex-col items-center text-center">
              <span className="material-symbols-outlined text-primary text-5xl mb-4">all_inbox</span>
              <h3 className="text-xl font-bold text-white">Revisión Multimarca</h3>
              <p className="text-text-muted-dark mt-2">Revisión completa y diagnóstico para todas las marcas del mercado.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Tecnología Superior */}
      <section className="py-16 px-4 sm:px-10 bg-[#111618]">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-bold mb-4 text-white">Utilizando una Tecnología Superior</h2>
            <p className="text-text-muted-dark mb-6">
              Nuestro centro de reacondicionamiento está equipado con la última tecnología para garantizar la máxima precisión y calidad en cada servicio. Contamos con tres estaciones de trabajo especializadas que nos permiten optimizar los tiempos de entrega sin comprometer la excelencia.
            </p>
            <ul className="space-y-4">
              <li className="flex items-start">
                <span className="material-symbols-outlined text-primary mr-3 mt-1">check_circle</span>
                <div>
                  <h4 className="font-bold text-white">Estación 1: Diagnóstico y Desmontaje</h4>
                  <p className="text-text-muted-dark">Inspección inicial exhaustiva y desmontaje cuidadoso de cada componente.</p>
                </div>
              </li>
              <li className="flex items-start">
                <span className="material-symbols-outlined text-primary mr-3 mt-1">check_circle</span>
                <div>
                  <h4 className="font-bold text-white">Estación 2: Reparación y Equilibrio</h4>
                  <p className="text-text-muted-dark">Uso de maquinaria de precisión para reparaciones y equilibrio dinámico.</p>
                </div>
              </li>
              <li className="flex items-start">
                <span className="material-symbols-outlined text-primary mr-3 mt-1">check_circle</span>
                <div>
                  <h4 className="font-bold text-white">Estación 3: Montaje y Pruebas Finales</h4>
                  <p className="text-text-muted-dark">Ensamblaje final y pruebas de rendimiento para asegurar la calidad superior.</p>
                </div>
              </li>
            </ul>
          </div>
          <div className="rounded-lg overflow-hidden">
            <img
              alt="Centro de reacondicionamiento de turbos"
              className="w-full h-full object-cover"
              src={turbo} // <-- usar la variable importada
            />
          </div>
        </div>
      </section>

      {/* Garantía */}
      <section className="py-16 px-4 sm:px-10 bg-card-dark">
        <div className="max-w-4xl mx-auto text-center">
          <span className="material-symbols-outlined text-primary text-6xl">verified_user</span>
          <h2 className="text-3xl font-bold mt-4 mb-4 text-white">Garantía y Cobertura de Piezas</h2>
          <p className="text-lg text-text-muted-dark">
            Todos nuestros servicios y piezas están respaldados por una garantía completa. Trabajamos con los mejores proveedores para asegurar la durabilidad y fiabilidad de cada componente, ofreciéndole tranquilidad y un rendimiento excepcional.
          </p>
        </div>
      </section>

      {/* Call to action */}
      <section className="py-20 px-4 sm:px-10 text-center bg-[#111618]">
        <h2 className="text-3xl font-bold text-white">¿Listo para Potenciar su Motor?</h2>
        <p className="text-text-muted-dark mt-4 mb-8 max-w-2xl mx-auto">
          Consulte nuestro catálogo completo de productos y servicios o solicite una cotización personalizada. Nuestro equipo de expertos está listo para ayudarle.
        </p>
        <div className="flex justify-center gap-4">
          <Link
            to="/productos"
            className="flex min-w-[84px] max-w-[480px] cursor-pointer items-center justify-center overflow-hidden rounded-lg h-12 px-6 bg-primary text-white text-base font-bold leading-normal tracking-[0.015em] transform hover:scale-105 transition-transform duration-200"
          >
            <span className="truncate">Ver Catálogo</span>
          </Link>
          <button className="flex min-w-[84px] max-w-[480px] cursor-pointer items-center justify-center overflow-hidden rounded-lg h-12 px-6 bg-transparent border-2 border-primary text-primary text-base font-bold leading-normal tracking-[0.015em] transform hover:bg-primary hover:text-white transition-colors duration-200">
            <span className="truncate">Solicitar Cotización</span>
          </button>
        </div>
      </section>
    </main>
  );
}